import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { activeShopMinInterval } from '../../auth/selectors';
import { getMinuteOptionsForMinInterval } from '../../main/selectors';

const mapStateToProps = (state, ownProps) => {
  const minInterval = ownProps.minInterval || activeShopMinInterval(state);
  return getMinuteOptionsForMinInterval(minInterval);
};

export const minuteOptionShape = PropTypes.arrayOf(PropTypes.number);

export default connect(mapStateToProps);
